export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-swipe-action/index.js